<template>
  <!-- Splitter vertical -->
  <Splitter
    class="col col-12 no_nav_height"
    layout="vertical"
    @onContext="onContext"
  >
    <!-- Row 1 (dividido en columnas) -->
    <SplitterPanel
      class="row f-row"
      :size="chartSizes.sizeSplitterRow1"
      :minSize="23.6"
      :style="
        `flex-basis: ${chartSizes.sizeSplitterRow1}%; height: ${chartSizes.sizeSplitterRow1}%;`
      "
    >
      <Layout1x1
        :assetTypes="assetTypes"
        :commoditySpecs="commoditySpecs"
        :currencySpecs="currencySpecs"
        :etfSpecs="etfSpecs"
        :futuresSpecs="futuresSpecs"
        :indexSpecs="indexSpecs"
        :irSpecs="irSpecs"
        :showLoadingComm="showLoadingComm"
        :showLoadingETF="showLoadingETF"
        :showLoadingFut="showLoadingFut"
        :showLoadingInd="showLoadingInd"
        :showLoadingIR="showLoadingIR"
        :colorTheme="colorTheme"
        :componentNumber="1"
        :currentLayout="overview_preferences['currentLayout'][0]"
        :allData="allData0"
        :message="message0"
        :nSelected="2"
        :processData="processData"
        :stopAssetType="stopAssetType"
        :TAVisible="TAVisible"
        @emitSpreadTable="emitSpreadTable"
        @eventOnChangeTerm="onChangeTerm"
        @eventOnSelectedAssetType="onSelectedAssetType"
        @eventOnUserAssetSelection="onUserAssetSelection"
        @eventOnUserAssetSelectionList="onUserAssetSelectionList"
        @eventOnUserAsset2Selection="onUserAsset2Selection"
        @eventOnUserClearComponent="onUserClearComponent"
        @eventOnUserSelectVisualization="onUserSelectVisualization"
        @eventOnUserShowFields="onUserShowFields"
        @eventOnUserShowTAChart="onUserShowTAChart"
      />
    </SplitterPanel>

    <SplitterGutter
      :index="0"
      :_this="context"
      :eventElement="newEventElement"
      :eventParentElement="eventParentElement"
      @resizestart="onResizePanel"
      @onResize="onResizePanel"
      @resizeend="onResizePanel"
    />

    <!-- Row 2 -->
    <SplitterPanel
      class="row f-row container-chart-layout-2x1"
      :size="chartSizes.sizeSplitterRow2"
      :minSize="23.6"
      :style="
        `flex-basis: ${chartSizes.sizeSplitterRow2}%; height: ${chartSizes.sizeSplitterRow2}%`
      "
    >
      <Layout1x1
        :assetTypes="assetTypes"
        :commoditySpecs="commoditySpecs"
        :currencySpecs="currencySpecs"
        :etfSpecs="etfSpecs"
        :futuresSpecs="futuresSpecs"
        :indexSpecs="indexSpecs"
        :irSpecs="irSpecs"
        :showLoadingComm="showLoadingComm"
        :showLoadingETF="showLoadingETF"
        :showLoadingFut="showLoadingFut"
        :showLoadingInd="showLoadingInd"
        :showLoadingIR="showLoadingIR"
        :colorTheme="colorTheme"
        :componentNumber="2"
        :currentLayout="overview_preferences['currentLayout'][1]"
        :allData="allData1"
        :message="message1"
        :nSelected="2"
        :processData="processData"
        :stopAssetType="stopAssetType"
        :TAVisible="TAVisible"
        @emitSpreadTable="emitSpreadTable"
        @eventOnChangeTerm="onChangeTerm"
        @eventOnSelectedAssetType="onSelectedAssetType"
        @eventOnUserAssetSelection="onUserAssetSelection"
        @eventOnUserAssetSelectionList="onUserAssetSelectionList"
        @eventOnUserAsset2Selection="onUserAsset2Selection"
        @eventOnUserClearComponent="onUserClearComponent"
        @eventOnUserSelectVisualization="onUserSelectVisualization"
        @eventOnUserShowFields="onUserShowFields"
        @eventOnUserShowTAChart="onUserShowTAChart"
      />
    </SplitterPanel>
  </Splitter>
</template>

<script>
import Layout1x1 from "@/components/overview/Layout1x1.vue";
import Splitter from "@/components/splitter/Splitter.vue";
import SplitterPanel from "@/components/splitter/SplitterPanel.vue";
import SplitterGutter from "@/components/splitter/SplitterGutter.vue";
import { defaultMessage } from "@/_core/data/Overview.js";
import { select } from "d3";

export default {
  name: "Layout2x1",
  components: {
    Layout1x1,
    Splitter,
    SplitterGutter,
    SplitterPanel
  },
  props: {
    assetTypes: { required: true, default: () => [] },
    commoditySpecs: { required: true, default: () => [] },
    currencySpecs: { required: true, default: () => [] },
    etfSpecs: { required: true, default: () => [] },
    futuresSpecs: { required: true, default: () => [] },
    indexSpecs: { required: true, default: () => [] },
    irSpecs: { required: true, default: () => [] },
    showLoadingComm: { required: true, type: Boolean, default: false },
    showLoadingETF: { required: true, type: Boolean, default: false },
    showLoadingFut: { required: true, type: Boolean, default: false },
    showLoadingInd: { required: true, type: Boolean, default: false },
    showLoadingIR: { required: true, type: Boolean, default: false },
    stopAssetType: { required: true, type: Boolean, default: false },
    TAVisible: { required: true, type: Number, default: -1 },
    // =======================================
    colorTheme: { required: true, type: Boolean, default: true },
    allData0: { required: true, default: () => [] },
    allData1: { required: true, default: () => [] },
    message0: { required: true, default: () => defaultMessage },
    message1: { required: true, default: () => defaultMessage },
    overview_preferences: { required: true, default: () => ({}) },
    processData: { required: true },
    eventElement: { required: false, default: () => PointerEvent }
  },
  data() {
    return {
      chartSizes: {
        sizeSplitterRow1: 50,
        sizeSplitterRow2: 50
      },
      context: {},
      newEventElement: PointerEvent,
      onChangeScenarios: false,
      eventParentElement: null
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {
    eventElement(newEvent) {
      const containerChartQty = select(".container-chart-layout-2x1");
      const parentNode =
        containerChartQty.node() && containerChartQty.node().nextSibling;

      this.newEventElement = newEvent;
      this.eventParentElement = parentNode;
      this.onChangeScenarios = true;
    }
  },
  methods: {
    onUserShowTAChart(val) {
      this.$emit("eventOnUserShowTAChart", val);
    },
    onContext(context) {
      this.context = context;
    },
    sizeSplitters({ isRestore = false }) {
      this.panels.forEach(panel => {
        const el = panel.$el.className;
        const selectElement = select(`.${el.split(" ").join(".")}`);
        if (isRestore) {
          selectElement
            .style(
              "height",
              `calc(${panel.size}% - ${(this.panels.length - 1) *
                this.context.gutterSize}px)`
            )
            .style(
              "flex-basis",
              `calc(${panel.size}% - ${(this.panels.length - 1) *
                this.context.gutterSize}px)`
            );
        }
      });
    },
    onResizePanel(value) {
      this.panels = value.panels;
      if (this.onChangeScenarios) {
        this.sizeSplitters({ isRestore: true });
      } else {
        this.sizeSplitters({});
      }
      this.onChangeScenarios = false;
    },
    onUserClearComponent(val) {
      this.$emit("eventOnUserClearComponent", val);
    },
    onUserSelectVisualization(component) {
      this.$emit("eventOnUserSelectVisualization", component);
    },
    onSelectedAssetType(val) {
      this.$emit("eventOnSelectedAssetType", val);
    },
    onUserAssetSelection(val) {
      this.$emit("eventOnUserAssetSelection", val);
    },
    onUserAssetSelectionList(val) {
      this.$emit("eventOnUserAssetSelectionList", val);
    },
    onUserAsset2Selection(val) {
      this.$emit("eventOnUserAsset2Selection", val);
    },
    onChangeTerm(val) {
      this.$emit("eventOnChangeTerm", val);
    },
    onUserShowFields(val) {
      this.$emit("eventOnUserShowFields", val);
    },
    emitSpreadTable(emitVars) {
      this.$emit("emitSpreadTable", emitVars);
    }
  },
  beforeDestroy: function() {},
  filters: {}
};
</script>

<style scoped>
.p-splitter {
  border: 0;
  background: 0;
  border-radius: 0;
  /* color: var(--red); */
}

div.p-splitter .p-splitter-gutter {
  border: 1px solid var(--lightbackground3);
  background: 0;
}

/* gutter horizontal (línea vertical entre columnas) */
div.p-splitter.p-splitter-horizontal .p-splitter-gutter {
  border-left: 1px solid var(--lightbackground3);
  border-right: 1px solid var(--lightbackground3);
  cursor: col-resize !important;
}

/* gutter vertical (línea horizontal entre filas) */
div.p-splitter.p-splitter-vertical .p-splitter-gutter {
  border-top: 1px solid var(--lightbackground3);
  border-bottom: 1px solid var(--lightbackground3);
  cursor: row-resize !important;
}
</style>
